import { useQuery, useQueryClient } from '@tanstack/react-query';
import { ErroApi } from '../api/cliente';
import { auth } from '../api/endpoints';
import type { Sessao } from '../api/tipos';

export const CHAVE_SESSAO = ['sessao'] as const;

/** Sessão atual (GET /api/auth/me). `null` quando não há sessão. */
export function useSessao() {
  return useQuery<Sessao | null>({
    queryKey: CHAVE_SESSAO,
    queryFn: async () => {
      try {
        return await auth.me();
      } catch (erro) {
        if (erro instanceof ErroApi && erro.status === 401) return null;
        throw erro;
      }
    },
    staleTime: 5 * 60_000,
    retry: false,
  });
}

export function useAtualizarSessao() {
  const cliente = useQueryClient();
  return (sessao: Sessao | null) => cliente.setQueryData(CHAVE_SESSAO, sessao);
}
